import { useEffect } from "react";
import { motion } from "framer-motion";

const Radio = (props) => {

  const {
    // isMobile,
    currentPage,
    setCurrentPage,
  } = props;

  useEffect(() => {
    if (currentPage !== "radio") {
      setCurrentPage("radio");
    }
  });

  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.4 } }}
      exit={{ opacity: 0, transition: { duration: 0.4 } }}
      key={"radio-wrapper"}
    >

    Radio
    </motion.main>
  )
}

export default Radio